import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { UnavailableDateComponent } from './unavailable-date.component';
import { UnavailableDateDetailComponent } from './unavailable-date-detail.component';
import { UnavailableDatePopupComponent } from './unavailable-date-dialog.component';
import { UnavailableDateDeletePopupComponent } from './unavailable-date-delete-dialog.component';

import { Principal } from '../../shared';

@Injectable()
export class UnavailableDateResolvePagingParams implements Resolve<any> {

    constructor(private paginationUtil: PaginationUtil) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        let sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'begining,desc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    }
}

export const unavailableDateRoute: Routes = [
    {
        path: 'unavailable-date',
        component: UnavailableDateComponent,
        resolve: {
            'pagingParams': UnavailableDateResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.unavailableDate.home.title'
        }
    }, {
        path: 'unavailable-date/:id',
        component: UnavailableDateDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.unavailableDate.home.title'
        }
    }
];

export const unavailableDatePopupRoute: Routes = [
    {
        path: 'unavailable-date-new',
        component: UnavailableDatePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.unavailableDate.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'unavailable-date/:id/edit',
        component: UnavailableDatePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.unavailableDate.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'unavailable-date/:id/delete',
        component: UnavailableDateDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'jYoguiApp.unavailableDate.home.title'
        },
        outlet: 'popup'
    }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/unavailable-date/unavailable-date.route.ts